// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	const windowWidth = screen.width;

	// Mobile Menu Functionality
	if(document.getElementById("header")){
		let menuContent = document.getElementById("menuContainer");
		let header = document.getElementById("header");
		let menuBtn = document.querySelector("[data-show_nav]");
		let closeBtn = document.querySelector("[data-close_nav]");
		// Show
		menuBtn.addEventListener('click', function (e) {
			menuContent.classList.add("open");
			header.classList.add("menuOpen");
			document.querySelector("body").classList.add("no-scroll");
		});
		// Close
		closeBtn.addEventListener('click', function (e) {
			menuContent.classList.remove("open");
			header.classList.remove("menuOpen");
			document.querySelector("body").classList.remove("no-scroll");
		});
	}

	/* Arrows Change Month Events Calendar */
	if(document.getElementsByClassName('js-month-prev').length > 0){
		document.querySelectorAll('.js-month-prev').forEach(prev => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let targetMonth = prev.dataset.date;
				if(prev.dataset.limit !== nextWeek.dataset.month){ 
					nextPrev.dataset.date = nextWeek.dataset.month;
					nextWeek.dataset.month = targetMonth;
					modifyMonth(prev,false,nextWeek);
					getEvents(targetMonth);
				}
			})
		})
		document.querySelectorAll('.js-month-next').forEach(next => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let targetMonth = next.dataset.date;
				prevNext.dataset.date = nextWeek.dataset.month;
				nextWeek.dataset.month = targetMonth;
				modifyMonth(next,true,nextWeek);
				getEvents(targetMonth);

			})
		})
	};

	function modifyMonth(el,add,nextWeek){
		let currentTarget = el.dataset.date.split('-');
		let dateConvert = new Date(currentTarget[1],parseInt(currentTarget[0]) - 1, 1);
		nextWeek.innerHTML = dateConvert.toLocaleString('default', { month: 'long' });
		if(add){
			dateConvert.setMonth(dateConvert.getMonth() + 1);
		} else {
			dateConvert.setMonth(dateConvert.getMonth() - 1);
		}
	
		let finalMonth = (dateConvert.getMonth() + 1)  < 10 ? '0' + (dateConvert.getMonth() + 1) : (dateConvert.getMonth() + 1) ;
		el.dataset.date = finalMonth + '-' +dateConvert.getFullYear();
		
	}

	// Capacity chart Tabs
	if(document.getElementsByClassName("capacity-chart")[0]){
		let capacityChart = document.querySelectorAll(".capacity-chart .filters .filter-js");
		for(let c = 0; c < capacityChart.length; c++){
			capacityChart[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentFilter = this.getAttribute("data-filter");
				document.querySelectorAll(".capacity-chart [data-filter]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.capacity-chart [data-filter="${currentFilter}"] `).forEach(item => { item.classList.add('active'); })
				
			});
			capacityChart[0].click();
		}
	}
	
	
	document.addEventListener('DOMContentLoaded', () => {

		/* Lightbox Copy */
		const customLightbox = new LBX('.js-lbx-copy', {
            customClass: 'lbx-copy',
        });

	})


	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelectorAll('.tabs-bg__filter li')) {
			let tabsPosts = document.querySelectorAll('.tabs-bg__filter li');
			let lastClick = null;
	
	
			tabsPosts.forEach((tab)=>{
				tab.addEventListener('click', (e)=>{
					let tag = e.target.dataset.tag;
					let items = document.querySelectorAll('.tabs-bg__item');
					if(lastClick){
						lastClick.classList.remove('active');
					}
					items.forEach((item)=>{
						item.classList.toggle('active',item.dataset.tag == tag)
					})
					tab.classList.add('active');
					lastClick = tab;
				})
			})
	
			tabsPosts[0].click();
		}       
    });

// For Offers Template
if (document.getElementById('terms_btn')) {
	let btnTerms = document.getElementById('terms_btn');
	let termsInfo = document.getElementById('terms_info');
	let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
	btnTerms.addEventListener('click', function(e) {
		e.preventDefault();
		termsInfo.classList.toggle('active');
		btnTerms.classList.toggle('active');
		if(termsInfo.classList.contains('active')){
			termsInfo.style.height = termsInfoHeight+"px";
		}else{
			termsInfo.style.height = 0+"px";
		}
	});
}

	/* Swiper Sliders */

    let swiperTop = document.querySelectorAll('.top-content');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            let swiperTopContent = new Swiper('.swiper-slides', {
                /*Optional parameters*/
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	

				allowTouchMove: false,
			
				navigation: {
					nextEl: '.swiper-button-next-topContent',
					prevEl: '.swiper-button-prev-topContent',
				}
            });
			let swiperPagination = new Swiper('.swiper-pagination-topContent', {
				/*Optional parameters*/
                loop: false,
				rewind: true,	
				autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
				navigation: {
					nextEl: '.swiper-button-next-topContent',
					prevEl: '.swiper-button-prev-topContent',
				},	
				slidesPerView: 1,
				on: {
					slideChange: function () {
						swiperTopContent.slideTo(this.activeIndex); // Synchronizes the second slider with the first slider
					}
				}		
            });
        });
    };
	let swiperReviews = document.querySelectorAll('.reviews-block');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
            let swiperReviews = new Swiper('.swiper-reviews', {
                /*Optional parameters*/
                loop: true,
				effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				autoHeight: true,
				allowTouchMove: false,
				
				navigation: {
					nextEl: '.swiper-button-next-reviews',
					prevEl: '.swiper-button-prev-reviews',
				},
            });
			let swiperPaginationReviews = new Swiper('.swiper-pagination-reviews', {
				/*Optional parameters*/
				loop: false,
				rewind: true,
				autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				navigation: {
					nextEl: '.swiper-button-next-reviews',
					prevEl: '.swiper-button-prev-reviews',
				},	
				slidesPerView: 1,
				on: {
					slideChange: function () {
						swiperReviews.slideTo(this.activeIndex); // Sincroniza el segundo slider con el primero
					}
				}		
			});
        });
    };

	let swiperSlider = document.querySelectorAll('.slider-block');
    if(swiperSlider){
        swiperSlider.forEach((item)=>{
            new Swiper('.swiper-slider', {
                /*Optional parameters*/
                loop: true,
				effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				autoHeight: true,
				
				navigation: {
					nextEl: '.swiper-button-next-slider',
					prevEl: '.swiper-button-prev-slider',
				},
            });
        });
    };

	let swiperSliderTC = document.querySelectorAll('.slider-two-columns');
    if(swiperSliderTC){
        swiperSliderTC.forEach((item)=>{
            new Swiper('.swiper-slider-tc', {
                /*Optional parameters*/
				loop:true,
				slidesPerView: 1,
				pagination: {
					el: ".slider-tc-pagination",
					clickable: true,
				},
				breakpoints: {
					640: {
						slidesPerView: "auto",
						navigation: {
							nextEl: '.swiper-button-next-slider-tc',
							prevEl: '.swiper-button-prev-slider-tc',
						},
					}
				}
            });
        });
    };

	let swiperTwoColumns = document.querySelectorAll('.two-columns');
    if(swiperTwoColumns){
        swiperTwoColumns.forEach((item)=>{
            new Swiper('.swiper-two-columns', {
                /*Optional parameters*/
				loop:true,
				slidesPerView: 1,
				pagination: {
					el: ".slider-two-columns-pagination",
					clickable: true,
				}
            });
        });
    };

	let swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{

			new Swiper(".gallery-block__swiper-mobile", {
				loop: true,
				slidesPerView: "1",
				allowTouchMove: false,
				pagination: {
					el: ".slider-gallery-pagination",
					clickable: true,
				}
			});
			
			var galSwiper1 = new Swiper('#gallerySwiper1', {
				loop: true,
				slidesPerView: "1",
				centeredSlides: false,
      			spaceBetween: 0,
				  initialSlide: 0,

				allowTouchMove: false,
				navigation: {
					nextEl: '.swiper-button-next-gallery',
					prevEl: '.swiper-button-prev-gallery',
				},
			});
			
			var galSwiper2 = new Swiper('#gallerySwiper2', {
				
				loop: true,
				slidesPerView: "1",
				centeredSlides: false,
      			spaceBetween: 0,
				  initialSlide: 1,

				allowTouchMove: false,
				navigation: {
					nextEl: '.swiper-button-next-gallery',
					prevEl: '.swiper-button-prev-gallery',
				},
			});
			
			var galSwiper3 = new Swiper('#gallerySwiper3', {
				loop: true,
				slidesPerView: "1",
				centeredSlides: false,
      			spaceBetween: 0,

				allowTouchMove: false,
				initialSlide: 2,
				
				navigation: {
					nextEl: '.swiper-button-next-gallery',
					prevEl: '.swiper-button-prev-gallery',
				},
			});
        });
    };

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

const logo = document.getElementsByClassName("header__logo")[0].firstElementChild;
const logoURL = logo.getAttribute("src");
const logoScrollURL = logo.getAttribute("data-scroll");

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(document.getElementById('home')){
		if(st > 80){
			if(!document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.add('scroll');
				logo.setAttribute("src", logoScrollURL);
			}
		} else {
			if(document.getElementById('header').classList.contains('scroll')){
				document.getElementById('header').classList.remove('scroll');
				logo.setAttribute("src", logoURL);
			}
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}else{
		logo.setAttribute("src", logoScrollURL);
	}
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
	const menu = document.querySelector('#menuContainer');
	const isMenuVisible = menu && menu.classList.contains('open');
	const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a, .tertiary-navigation__item a, .social-media a');

	elements.forEach(element => {
		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	});
}
document.addEventListener('DOMContentLoaded', () => {
	updateMenuTabIndex();

	document.addEventListener('focusin', updateMenuTabIndex);
	const menu = document.querySelector('#menuContainer');
	if (menu) {
		menu.addEventListener('transitionend', updateMenuTabIndex);
	}
});